import { render, staticRenderFns } from "./set-referrer-discount.vue?vue&type=template&id=55c846e3&scoped=true&"
import script from "./set-referrer-discount.vue?vue&type=script&lang=js&"
export * from "./set-referrer-discount.vue?vue&type=script&lang=js&"
import style0 from "./set-referrer-discount.vue?vue&type=style&index=0&id=55c846e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c846e3",
  null
  
)

export default component.exports